import React from 'react'
import { Button } from './primary'
import { useViewport } from '../../utils'
import { useInternationalization } from '../../features/i18n'

const SaveButton = ({className, mobileClassname, saveText, ...props}) => {
  const { isMobile } = useViewport()
  const { language } = useInternationalization()

  return (
    <div>
      <Button
        style={!isMobile ? {width: '197px'} : {}}
        className={isMobile ? mobileClassname : ``}
        thin={isMobile}
        {...props}
      >
        {
          saveText ? saveText : (language.name === 'en' ? 'Save' : 'Simpan')
        }
      </Button>
    </div>
  )
}

export { SaveButton }
